/*==============================================================================
  
THEME.JS
  
  #SLATE ........................................ Shopify helpers and utilities based on Shopify Slate

  slate.a11y .................................... Accessibility helpers
  slate.utils ................................... Utility helpers for dealing with arrays and objects. Customised to add helpers for linked product options
  slate.rte ..................................... Rich Text Editor helpers 
  theme.Sections ................................ Custom Sections functionality based on Slate with minor adjustments
  slate.Currency ................................ Currency helpers
  slate.Image ................................... Image helpers
  slate.Variants ................................ Variant selection event triggers. Modified to add more events.


  #CONFIG & UTILITIES ........................... General config and utilities

  theme.config .................................. General config for breakpoints, touch devices, etc.
  theme.mq ...................................... Media queries matching our CSS
  theme.setBreakpoints .......................... Event listeners to set breakpoints based on Enquire JS in vendor.js
  theme.CartUtilities ........................... AJAX Shopify Cart API utilities
  theme.AjaxProduct ............................. AJAX Add Product Functionality
  theme.loadImageSection ........................ Allows for adding classes whilst loading so we can animate


  #MODULES ...................................... General modules

  theme.Modals .................................. Modals module
  theme.Drawers ................................. Drawers module using prototypes
  theme.Collapsibles ............................ Collapsibles module


  #SECTIONS ..................................... Shopify Sections

  theme.HeaderSection ........................... Header
  theme.AnnouncementBarSection .................. Rotating announcement bar (Flickity)
  theme.StickyHeader ............................ Desktop fixed header hide/show on scroll
  theme.DrawerMenuSection ....................... Drawer Menu
  theme.Cart .................................... Handles major cart related functionality on both Cart page and AJAX drawer
  theme.Product ................................. Product
  theme.ProductRecommendations .................. Product Recommendations
  theme.RecentlyViewedProducts .................. Recently Viewed Products
  theme.Collection .............................. Collection
  theme.SlideshowSection ........................ Slideshow based on FLICKITY in vendor.js
  theme.FeaturedCollectionSection ............... Featured Collection


  #TEMPLATES .................................... Functionality specific to Shopify Templates

  theme.customerAddresses ....................... Customer Address form functionality
  theme.customerLogin ........................... Customer Login page functionality


  #INIT ......................................... Main init to run various modules and uncategorised code including tab handling for accessibility

  - Tab handling to maintain accessibility
  - theme.setBreakpoints();
  - theme.Cart.init();
  - theme.Modals.init();
  - theme.Collapsibles.init();


  #DOC READY .................................... Document Ready functions
  
  - Run theme.init
  - Register theme sections
  - Run common a11y fixes
  - Run RTE helpers to convert RTE tables to scrollable elements
  - Run RTE iframe helpers to make RTE iFrames responsive


==============================================================================*/




window.slate = window.slate || {};
window.theme = window.theme || {};





/*==============================================================================
  #SLATE a11y
==============================================================================*/

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }

};










/*==============================================================================
  #SLATE Utility Helpers
==============================================================================*/

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 *
 * #EDIT
 * - Added arrayIncludes and uniq utilities for linked product options
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },


  /**
   * A utility from Shopify option_selection.js needed for linked product
   * options.
   */
  arrayIncludes: function(e, t) {
    for (var n = 0; n < e.length; n++)
        if (e[n] == t) return !0;
    return !1
  }, 


  /**
   * A utility from Shopify option_selection.js needed for linked product
   * options.
   */
  uniq: function(e) {
      for (var t = [], n = 0; n < e.length; n++) slate.utils.arrayIncludes(t, e[n]) || t.push(e[n]);
      return t
  }
};










/*==============================================================================
  #SLATE Rich Text Editor
==============================================================================*/

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};










/*==============================================================================
  #THEME Sections
==============================================================================*/

/**
 * Sections
 * - Largely based on Slate and Impulse theme with some minor adjustments.
 * - https://help.shopify.com/en/themes/development/sections#understand-the-interaction-between-theme-javascript-and-the-theme-editor
 * - Added support for subsections
 * - Added simpler findInstance and removeInstance functions
 */


theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  // Register event listeners for section events
  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {

  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  // We are using subSections for dynamic non-homepage section blocks
  _onSectionLoad: function(evt, subSection, subSectionId) {

    // Check if we have a subSection or a Section
    var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];

    // If no subSection or Section exists, stop running
    if (!container) {
      return;
    }

    // Register section
    this._createInstance(container);

    // Store subSection or Section ID as an instance
    var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

    // #? I don't understand this. Why is it loading subsections, if a
    // subsection doesn't exist?
    if (!subSection) {
      this._loadSubSections();
    }

    // Run JS only in case of the section being selected in the editor
    // before merchant clicks "Add"
    if (instance && typeof instance.onLoad === 'function') {
      instance.onLoad(evt);
    }
  },

  // Look for `data-subsection` attributes and load them
  _loadSubSections: function() {
    $('[data-subsection]').each(function(evt, el) {
      this._onSectionLoad(null, el, $(el).data('section-id'));
    }.bind(this));
  },

  _onSectionUnload: function(evt) {
    var instance = this._removeInstance(evt.detail.sectionId);

    if (instance && typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }
  },

  _onSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  // A simpler version of findInstance specific to sections
  _findInstance: function(id) {
    for (var i = 0; i < this.instances.length; i++) {
      if (this.instances[i].id === id) {
        return this.instances[i];
      }
    }
  },

  // A simpler version of removeInstance specific to sections
  _removeInstance: function(id) {
    var i = this.instances.length;
    var instance;

    while(i--) {
      if (this.instances[i].id === id) {
        instance = this.instances[i];
        this.instances.splice(i, 1);
        break;
      }
    }

    return instance;
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;
    var $sections = $('[data-section-type=' + type + ']');

    $sections.each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});










/*==============================================================================
  #SLATE Currency
==============================================================================*/

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();










/*==============================================================================
  #SLATE Image
==============================================================================*/

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 * #EDIT: Added default size of 620x to imageSize function
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   *
   * Added default size of 620x
   */
  function imageSize(src) {
    if (!src) {
      return '620x'; // default based on theme
    }

    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();










/*==============================================================================
  #SLATE Variants
==============================================================================*/

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 *
 * #EDIT: 
 * - Added _updateSKU function
 * - Added _updateVariantButtons function for linked options
 * - Updated _getVariantFromOptions code to be simpler
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var match = true;
        var options = variant.options

        selectedValues.forEach(function(option) {
          if (match) {
            match = (variant[option.index] === option.value);
          }
        });

        if (match) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      console.log('hello called');
      var variant = this._getVariantFromOptions();
      console.log('hello called', variant);

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._updateVariantButtons(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }
      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },


    /**
     * CUSTOM EVENT. If using buttons for our variants and linked options,
     * trigger change when selecting another button variant
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantButtonChange
     */
    _updateVariantButtons: function(variant) {
      this.$container.trigger({
        type: 'variantButtonChange',
        variant: variant
      });
    },


    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();




















/*==============================================================================
  #CONFIG & UTILITIES
==============================================================================*/

/**
 * There is no accurate way of detecting a touch device using JS. Ideally, you
 * would wait for a users first iteraction and determine if it's a touch or
 * mouse move:
 * https://blogs.perficientdigital.com/2017/11/21/detecting-the-use-of-a-touch-screen/
 *
 * `ontouchstart` is used by Modernizer:
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js#L40
 * 
 * `DocumentTouch`: very old and obsolete API since Gecko 25 (Firefox 25). Also
 * used by Modernizr.
 * https://developer.mozilla.org/en-US/docs/Web/API/DocumentTouch
 *
 * `maxTouchPoints`: returns number of touch contact points connected to the
 * device. Might not be best idea? Supported by Chrome Android, but not iOS.
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/maxTouchPoints
 *
 * `msMaxTouchPoints`: Only works for IE10. Future IEs removed this and used
 * standard `maxTouchPoints`:
 * https://technet.microsoft.com/en-us/windows/hh772144(v=vs.60)
 *
 * `matchMedia`: Similar to Prestige theme. matchMedia support is here:
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
 *
 * `moz-touch-events` no longer available to web content since Firefox 58:
 * https://developer.mozilla.org/en-US/docs/Web/CSS/@media/-moz-touch-enabled
 *
 * `isIpad` uses the JS test method to check if the userAgent matches the
 * string of `ipad`. Read negative things about userAgent detection but mainly
 * from long time ago. This iPad setting was used on Impulse theme to add a
 * 'js-ipad' class to body and change some background attachments to initial.
 * We won't need it.
 */


theme.config = {
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false || window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches,
  bpSmall: false
};


theme.mq = {
  small: 'screen and (max-width: 767px)',
  medium: 'screen and (min-width: 768px) and (max-width: 1024px)',
  large: 'screen and (min-width: 1025px) and (max-width: 1440px)',
  widescreen: 'screen and (min-width: 1441px)',
  massive: 'screen and (min-width: 1800px)'
};





theme.setBreakpoints = function() {
  enquire.register(theme.mq.small, {
    match: function() {
      theme.config.bpSmall = true;
    },

    unmatch: function() {
      theme.config.bpSmall = false;
    }
  });
}










/*==============================================================================
  #Cart
  - Ajax Shopify API Utilities
==============================================================================*/

theme.CartUtilities = {
  getCart: function() {
    return $.getJSON('/cart.js');
  },

  changeItem: function(key, qty) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id=' + key,
      dataType: 'json'
    });
  },

  addItemFromForm: function(data) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json'
    });
  },

  _updateCart: function(params) {
    return $.ajax(params)
      .then(function(cart) {
        return cart;
      }.bind(this))
  },

  updateNote: function(note) {
    var params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + theme.CartUtilities.attributeToString(note),
      dataType: 'json',
      success: function(cart) {},
      error: function(XMLHttpRequest, textStatus) {}
    };

    $.ajax(params);
  },

  attributeToString: function(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return $.trim(attribute);
  }
}










/*==============================================================================
  #AjaxProduct
==============================================================================*/

theme.AjaxProduct = (function() {
  var status = {
    loading: false
  };

  function ProductForm($form) {
    this.$form = $form;
    this.$addToCart = this.$form.find('.js-add-to-cart');

    if (this.$form.length) {
      this.$form.on('submit', this.addItemFromForm.bind(this));
    }
  };

  ProductForm.prototype = $.extend({}, ProductForm.prototype, {
    addItemFromForm: function(evt, callback){
      evt.preventDefault();

      if (status.loading) {
        return;
      }

      // Loading indicator on add to cart button
      this.$addToCart.addClass('btn--loading');

      status.loading = true;

      var data = this.$form.serialize();

      theme.CartUtilities.addItemFromForm(data)
        .then(function(product) {
          this.success(product);
        }.bind(this))
        .catch(function(XMLHttpRequest) {
          this.error(XMLHttpRequest)
        }.bind(this))
        .always(function() {
          status.loading = false;
          this.$addToCart.removeClass('btn--loading');
        }.bind(this));
    },

    success: function(product) {
      this.$form.find('.alert--error').remove();
      $('body').trigger('added.ajaxProduct');
    },

    error: function(XMLHttpRequest) {
      this.$form.find('.alert--error').remove();

      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);

        this.$addToCart.after('<div class="alert  alert--error  alert--spacing">' + XMLHttpRequest.responseJSON.description + '</div>');
      }
    }
  });

  return ProductForm;
})();










/*==============================================================================
  # Theme Load Image Section
  - Allows for adding classes whilst loading so we can animate
==============================================================================*/

theme.loadImageSection = function($container) {
  // Wait until images inside container have lazyloaded class
  function setAsLoaded() {
    $container.removeClass('loading loading--delayed').addClass('loaded');
  }

  function checkForLazyloadedImage() {
    return $container.find('.lazyloaded').length;
  }

  // If it has SVGs it's in the onboarding state so set as loaded
  if ($container.find('svg').length) {
    setAsLoaded();
    return;
  };

  if (checkForLazyloadedImage() > 0) {
    setAsLoaded();
    return;
  }

  var interval = setInterval(function() {
    if (checkForLazyloadedImage() > 0) {
      clearInterval(interval);
      setAsLoaded();
    }
  }, 80);
};




















/*==============================================================================
  #MODULES
==============================================================================*/


/*==============================================================================
  #Modals
==============================================================================*/

theme.Modals = (function() {

  var selectors = {
    activeModal: '.modal--is-visible',
    openModal: '.js-open-modal',
    closeModal: '.js-close-modal',
    modalContent: '.modal__content'
  };

  var config = {
    activeModal: 'modal--is-visible',
    namespace: '.modal'
  }

  var $activeModal = $(selectors.activeModal);
  var modalIsOpen;
  var $html = $('html');

  if ($activeModal.length) {
    modalIsOpen = true;
  }

  function init() {
    $(selectors.openModal).on('click' + config.namespace, openModal);
    $(selectors.closeModal).on('click' + config.namespace, closeModal);

    /**
     * This event is triggered by theme.Drawers.open and ensures we close
     * the modal when the cart drawer is opened.
     */
    $('body').on('drawerOpen', function() {
      closeModal();
    });
  }

  function openModal(evt) {

    // Make sure no other modal is already open. If so, close it.
    if (modalIsOpen) {
      closeModal();
    }

    evt.preventDefault();

    // Get Modal by ID tag. The aria-controls of the open button will match the ID of the modal.
    var $target = $(evt.currentTarget)
    var targetId = $target.attr('aria-controls');
    var $modal = $('#' + targetId);

    // Add active modal class
    $modal.addClass(config.activeModal);

    // Change aria-hidden
    $modal.attr('aria-hidden', 'false');

    // Add no scroll class to html
    $html.addClass('no-scroll');

    // Set $activeModal to the opened modal
    $activeModal = $modal;
    modalIsOpen = true;

    // Bind events
    bindEvents();
  }


  function closeModal(evt) {

    // Check that a modal is open. If not, return.
    if (!modalIsOpen) {
      return;
    }

    // Remove active class
    $activeModal.removeClass(config.activeModal);

    // Change aria-hidden
    $activeModal.attr('aria-hidden', 'true');

    // Remove no scroll class to html
    $html.removeClass('no-scroll');

    // Set $activeModal to false
    modalIsOpen = false;

    // Unbind Events
    unbindEvents();
  }


  function bindEvents() {

    // Close modal on ESC
    $(document).on('keyup' + config.namespace, function(evt) {
      if (evt.keyCode === 27) {
        closeModal();
      }
    })

    // Clicking outside of modal will close it
    $activeModal.on('click' + config.namespace, function(evt) {
      closeModal();
    });

    // However, we don't want it closed when clicking on modal content.
    $(selectors.modalContent).on('click' + config.namespace, function(evt) {
      evt.stopImmediatePropagation();
    });
  }


  function unbindEvents() {

    // Remove escape keyup event
    $(document).off('keyup' + config.namespace);

    // Remove $activeModal click
    if ($activeModal) {
      $activeModal.off('click' + config.namespace);
    }

    // Remove modalContent click
    $(selectors.modalContent).off('click' + config.namespace);
  }

  return {
    init: init
  }

})();










/*==============================================================================
  #Drawers

   - Largely based off Shopify Timber Drawers, with inspiration from Pushy JS,
      and Drawer.js
    
    WHAT IT DOES:
    - This allows us to create multiple off-canvas drawers
    - We use a constructor function and create an instance for each drawer we
      would like
    - We use prototypes to add methods to our constructor that can be shared
      amongst all our drawer instances
    - Due to using prototypes, we must use `this.[property]` to expose variables
      to our prototype methods.

    HOW TO USE:
    - Create an instance of a drawer such as:

    var drawerVariableName = new Drawer(drawerId, drawerName)
==============================================================================*/

theme.Drawers = (function() {

  function Drawer(drawerId, drawerName) {

    this.id = drawerId;
    this.name = drawerName;

    this.selectors = {
      html: document.documentElement,
      body: 'body',
      MainContent: '#MainContent',
      overlay: '.drawer-overlay',

      openBtn: '.js-drawer-open-' + drawerName,
      closeBtn: '.js-drawer-close'
    };

    this.cache = {
      $html: $(this.selectors.html),
      $body: $(this.selectors.body),
      $parent: $(this.selectors.html),
      $mainContent: $(this.selectors.mainContent),
      $overlay: $(this.selectors.overlay),

      $openBtn: $(this.selectors.openBtn),
      $closeBtn: $(this.selectors.closeBtn)
    };

    // Config object
    this.config = {
      open: 'js-drawer-is-open',
      noScroll: 'no-scroll',

      activeDrawer: 'drawer--is-open',
      activeOverlay: 'drawer-overlay--is-visible',

      namespace: '.drawer-' + name
    };

    // cache our drawer
    this.$drawer = $('#' + this.id);

    // Check if drawer exists
    if (!this.$drawer.length) {
      return false;
    }

    // Drawer flag to indicate if open or closed
    this.drawerIsOpen = false;

    // Last focus variable which will store the element that was focused prior
    // to opening the drawer
    this.$lastFocus = null;

    // Initialise our drawers
    this.init();
  };


  Drawer.prototype = $.extend({}, Drawer.prototype, {

    /* Drawer Init
     ======================================================================== */
    init: function() {
      var $openBtn = this.cache.$openBtn;

      // Attach aria-attributes on initialisation
      $openBtn.attr({
        'aria-controls': '#' + this.id,
        'aria-expanded': 'false'
      });

      /**
       * Open event handler. We use `.bind` to ensure that `this` refers to our 
       * Drawer object, not the jQuery object that is handling our event.
       */    
      $openBtn.on('click' + this.config.namespace, this.open.bind(this));
    },


    /* Drawer Open
     ======================================================================== */
    open: function(evt) {

      /**
       * When opening a drawer via a link we want to prevent the default 
       * behaviour of a link click event.
       *
       * When we open a drawer externally such as a Cart Drawer opening when 
       * an item is added to cart, `evt.preventDefault` encounters an error 
       * because there is no event, so evt is undefined.
       *
       * So, we use a conditional statement to check if our a drawer is opened
       * through an event/link click or externally.
       */
      if (evt) {
        evt.preventDefault();
      }

      // Defensive code to ensure that you can't open an already opened drawer
      if (this.drawerIsOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer. Doesn't cause issues for me.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();

        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }


      // Store our last focused element before opening the drawer as jQuery object
      this.$lastFocus = $(document.activeElement);

      // Show drawer
      this.$drawer.addClass(this.config.activeDrawer);

      // Add noScroll class to html/body
      this.cache.$parent.addClass(this.config.noScroll);
      this.cache.$overlay.addClass(this.config.activeOverlay);

      // Set active flag to true
      this.drawerIsOpen = true;

      // Trap focus to drawer
      slate.a11y.trapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      // Having this trigger, will allow us to close any modals/other elements
      // that may affect the drawer. An example is if we use a quickview modal
      // and add to cart, we want to close the modal, and open the cart drawer.
      $('body').trigger('drawerOpen');

      // Aria-expanded to true
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }

      // Bind close drawer event handlers
      this.bindEvents();
    },


    /* Drawer Close
     ======================================================================== */
    close: function(evt) {
      console.log('run close');

      if (evt) {
        console.log(evt);
        evt.preventDefault();
      }

      // Defensive code to ensure you can't close a closed drawer
      if (!this.drawerIsOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      // Close drawer
      this.$drawer.removeClass(this.config.activeDrawer);

      // Remove noScroll
      this.cache.$parent.removeClass(this.config.noScroll);
      this.cache.$overlay.removeClass(this.config.activeOverlay);

      // Set flag to false
      this.drawerIsOpen = false;

      // Remove focus
      slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      // Aria-expanded to false
      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false');
      }

      // Return focus to the element prior to opening our drawer    
      if (this.$lastFocus !== null) {
        this.$lastFocus.focus();     
      }

      // Unbind close drawer event handlers
      this.unbindEvents();
    },



    /* Drawer Bind Events
    ========================================================================= */
    bindEvents: function() {

      // Close on click of close button
      this.cache.$closeBtn.on('click' + this.config.namespace, this.close.bind(this));

      // Close on click of overlay
      this.cache.$overlay.on('click' + this.config.namespace, function (evt) {
          this.close();
      }.bind(this));

      // Close on keypress of escape key
      this.cache.$parent.on('keyup' + this.config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
    },


    /* Drawer Unbind Events
    ========================================================================= */
    unbindEvents: function() {
      this.cache.$parent.off(this.config.namespace);
      this.cache.$overlay.off(this.config.namespace);
      this.cache.$closeBtn.off(this.config.namespace);
    }

  });

  return Drawer;
})();










/*==============================================================================
  #Collapsibles
==============================================================================*/

/**
 * For smooth collapsibles we need to use height transitions. This is not 
 * supported in CSS, so we have to use JS.
 * https://css-tricks.com/using-css-transitions-auto-dimensions/#article-header-id-3
 */

theme.Collapsibles = (function() {

  var selectors = {
    keepMultipleOpen: '[data-keep-multiple-collapsibles-open]',
    collapsible: '.collapsible',
    button: '.collapsible__heading',
    panel: '.collapsible__panel',
    panelContent: '.collapsible__panel-content',
    activeCollapsible: '.collapsible--is-open'
  };

  var config = {
    activeCollapsible: 'collapsible--is-open',
    keepMultipleOpen: false
  }


  function init() {
    // Event handler on click
    $(selectors.button).on('click', function(evt) {

      // Get current event target which will be the collapsible button
      var $target = $(evt.currentTarget);

      // Get keepMultipleOpen selector if it exists
      var $keepMultipleOpen = $target.closest(selectors.keepMultipleOpen);

      /**
       * If we have a data-keep-multiple-collapsibles-open attribute on the
       * collapsible wrapper, we set the flag to true.
       */

      if ($keepMultipleOpen.length) {
        config.keepMultipleOpen = true;
      } else {
        config.keepMultipleOpen = false;
      }


      /**
       * If we have nested collapsibles, we ensure that click events don't bubble
       * so a nested collapsible doesn't open and then close.
       */
      evt.stopPropagation();

      // Pass our $target to toggleCollapsible function
      toggleCollapsible($target);
    });
  };



  // Pass in our $target element (the button that was clicked)
  function toggleCollapsible($target) {

    // Get the parent collapsible
    var $parentCollapsible = $target.closest(selectors.collapsible);

    // Get the collapsiblePanel
    var $collapsiblePanel = $parentCollapsible.find('> ' + selectors.panel);;


    /**
     * Check if the collapsible is open or closed and run the relevant function
     * passing in the parentCollapsible and collapsiblePanel
     */
    if ($parentCollapsible.hasClass(config.activeCollapsible)) {
      closeCollapsible($parentCollapsible, $collapsiblePanel);
    } else {
      openCollapsible($parentCollapsible, $collapsiblePanel);
    }


    /**
     * If we want only one collapsible open at a time, we run this function
     * to close sibling collapsibles
     */
    if (!config.keepMultipleOpen) {

      $parentCollapsible.siblings(selectors.collapsible).each(function(index, element) {

        // This stores all parentCollapsibles
        var $parent = $(element);

        // This stores all collapsiblePanels
        var $panel = $parent.find('> ' + selectors.panel);

        closeCollapsible($parent, $panel);
      });
    }
  };


  // Pass in the parent collapsible, and collapsible panel
  function openCollapsible($parentCollapsible, $collapsiblePanel) {

    // If already open, skip this function
    if ($parentCollapsible.hasClass(config.activeCollapsible)) {
      return;
    }

    /**
     * As we may have nested collapsibles, we need to ensure we get the direct
     * descendant toggleButton
     */
    var $toggleButton = $parentCollapsible.find('> ' + selectors.button);

    // Add aria expanded
    $toggleButton.attr('aria-expanded', true);


    // Get panel height
    var panelHeight = $collapsiblePanel.first().prop("scrollHeight");

    // We need to declare an explicit height before setting to auto
    $collapsiblePanel.css({
      'overflow': 'visible',
      'height' : panelHeight + 'px'
    });

    // On completion of CSS transition, we set height to auto
    var transitionEnded = function transitionEnded(evt) {
      if (evt.originalEvent.propertyName === 'height') {
        $collapsiblePanel.css('height', 'auto');
        $collapsiblePanel.off('transitionend');
      }
    };

    $collapsiblePanel.on('transitionend', transitionEnded);

    // Add active class. This needs to be placed last to not interfere with
    // CSS height changes
    $parentCollapsible.addClass(config.activeCollapsible);

  }


  function closeCollapsible($parentCollapsible, $collapsiblePanel) {

    // If already closed, skip this function
    if (!$parentCollapsible.hasClass(config.activeCollapsible)) {
      return;
    }

    /**
     * As we may have nested collapsibles, we need to ensure we get the direct
     * descendant toggleButton
     */
    var $toggleButton = $parentCollapsible.find('> ' + selectors.button);

    // Add aria expanded
    $toggleButton.attr('aria-expanded', false);

    var panelHeight = $collapsiblePanel.first().prop("scrollHeight");

    $collapsiblePanel.css({
      'overflow': 'hidden',
      'height' : panelHeight + 'px'
    });

    var offsetHeight = $collapsiblePanel.outerHeight();

    $collapsiblePanel.css({
      'height' : offsetHeight + 'px'
    });

    $collapsiblePanel.css({
      'height' : '0'
    });

    // Remove active class. This needs to be placed last to not interfere with
    // CSS height changes
    $parentCollapsible.removeClass(config.activeCollapsible);
  }


  return {
    init: init
  };
})();










/*==============================================================================
  #AJAX Newsletter Form - Mailchimp
==============================================================================*/

theme.ajaxNewsletterForm = function() {

  // Set variables for footer and popup classes
  var $newsletterFooter = $('.js-newsletter-footer');

  var $newsletterFooterResponse = $('.js-newsletter-footer-response');

  // Our submit event listener for a specific form
  function ajaxMailChimpForm($form, $responseElement) {
    $form.submit(function(evt){
      evt.preventDefault();
      submitForm($form, $responseElement);
    });
  }


  // Submit form event handler
  function submitForm($form, $responseElement) {
    try {
      console.log('sending google event');
    ga('send', 'event', 'Form Submission', 'click', 'Email Sign Up');
    } 
    
    catch(e) {
    console.log('e', e);
    }
    

    $.ajax({
      type: "GET",
      url: $form.attr("action"),
      data: $form.serialize(),
      cache: false,
      dataType: "jsonp",
      jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",

      error: function(error) {
        // According to jquery docs, this is never called for cross-domain JSONP requests
        alert("Could not connect to the server. Please try again later.");
      },

      success: function(data, textStatus, jqXHR) {
        var successMessage = $('.newsletter-response').attr('data-newsletter-success');
        var alreadySubscribedMessage = $('.newsletter-response').attr('data-newsletter-already-subscribed');

        if (data.result != "success") {
          if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
            $responseElement.removeClass('newsletter-alert--success').addClass('newsletter-alert--error');
            $responseElement.html(alreadySubscribedMessage).show();

          } else {
            $responseElement.removeClass('newsletter-alert--success').addClass('newsletter-alert--error');
            $responseElement.html(data.msg).show();
          }

        } else {
          $responseElement.removeClass('newsletter-alert--error').addClass('newsletter-alert--success');
          $responseElement.html(successMessage).show();
        }
      }
    });
  }

  // Run the code for each newsletter form on your page
  ajaxMailChimpForm($newsletterFooter, $newsletterFooterResponse);
}




















/*==============================================================================
  #SECTIONS
==============================================================================*/

/*==============================================================================
  #HeaderSection
==============================================================================*/

theme.HeaderSection = (function() {

  function Header(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings') || '{}');

    var selectors = this.selectors = {
      header: '.header'
    };

    var cache = this.cache = {
      $header: $(this.selectors.header),
      $headerSearch: $('.header-search'),
      $openSearch: $('.js-open-search'),
      $closeSearch: $('.js-close-search')
    };

    var config = this.config = {
      headerNamespace: '.header',
      searchIsOpen: 'header-search--is-open'
    };

    this.initDrawers();
    this.initHeaderSearch();

    if (typeof theme.StickyHeader !== 'undefined') {
      theme.StickyHeader.init();
    }
  }

  Header.prototype = $.extend({}, Header.prototype, {

    initDrawers: function() {
      theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');

      if (theme.settings.cartType === 'drawer') {
        theme.CartDrawer = new theme.Drawers('CartDrawer', 'cart');
      }
    },

    initHeaderSearch: function() {
      this.cache.$openSearch.on('click', this.toggleSearch.bind(this));
    },

    toggleSearch: function(evt) {
      evt.preventDefault();

      if (this.cache.$headerSearch.hasClass(this.config.searchIsOpen)) {
        this.closeSearch();
      } else {
        this.openSearch();
      }
    },

    openSearch: function(evt) {
      var self = this;

      self.cache.$headerSearch.addClass(self.config.searchIsOpen);
      self.cache.$closeSearch.on('click.headerSearch', this.closeSearch.bind(this));
      setTimeout("$('.header-search__input').focus();", 300);
    },

    closeSearch: function(evt) {
      var self = this;

      self.cache.$headerSearch.removeClass(self.config.searchIsOpen);
      self.cache.$closeSearch.off('click.headerSearch');
    },

    onSelect: function() {
      if (theme.HeaderNav && typeof theme.HeaderNav.init === 'function') {
        theme.HeaderNav.init();
      }
      if (typeof theme.StickyHeader !== 'undefined') {
        theme.StickyHeader.setHeight();
      }
    }

  });

  return Header;

})();










/*==============================================================================
  #DrawerMenuSection
  - Our Drawer Menu is registered as a section hence a separate JS section
    module. Majority of functions here ensure the drawer works smoothly in
    the Theme Editor.
==============================================================================*/

theme.DrawerMenuSection = (function() {

  function DrawerMenuSection(container) {
    this.init();
  }

  DrawerMenuSection.prototype = $.extend({}, DrawerMenuSection.prototype, {


    init: function() {
      this.onUnload();
      theme.DrawerMenu = new theme.Drawers('NavDrawer', 'nav');
    },

    /**
     * Shopify Theme Editor events
     */

    forceReload: function() {
      this.init();
    },

    onSelect: function() {
      theme.DrawerMenu.open();
      // theme.Collapsibles.init();
    },

    onDeselect: function() {
      theme.DrawerMenu.close();
    },

    onUnload: function() {
      if (theme.DrawerMenu) {
        theme.DrawerMenu.close();
      }
    }
  });

  return DrawerMenuSection;
})();










/*==============================================================================
  #Cart
  - This code handles major cart related functionality on both the cart page and
    the AJAX cart drawer.
==============================================================================*/

theme.Cart = (function() {

  var itemCount = window.theme.settings.cartCount;
  var loading = false;


  function init() {
    /**
     * On custom event `added.ajaxProduct` we run buildCart. This is triggered 
     * in `theme.ProductForm`. We don't place this in our initEventListeners()
     * function as we don't need to re-run this, as it's triggered elsewhere.
     *
     * The function will run the AJAX request to get our cart. We need to pass
     * this cart object in to our buildCart function.
     */
    $('body').on('added.ajaxProduct', function() {
      theme.CartUtilities.getCart().then(function(cart) {
        buildCart(cart);
      }.bind(this));
    }.bind(this));

    // Store cart note when AJAX cart changes
    $('body').on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      theme.CartUtilities.updateNote(newNote);
    });
    
    initEventListeners();
  };


  function initEventListeners() {

    /**
     * Quantity related event listeners
     */
    $('.js-qty-increase').on('click', updateQuantity);
    $('.js-qty-decrease').on('click', updateQuantity);
    $('.js-qty-input').on('blur', updateQuantity);
  };


  function updateQuantity(evt) {

    // Prevent default link behaviour for remove link
    evt.preventDefault();

    // Store our target element
    var $target = $(evt.currentTarget);

    // Set quantity
    var parsedQuantity = 1;

    // Get variant ID
    var id = $target.attr('data-line-id');

    // If target is our input element
    if ($target.hasClass('js-qty-input')) {

      // Get the current value
      var currentValue = parseInt($target.attr('data-current-value'));

      // Get the new user-input value
      parsedQuantity = parseInt($target.val());

      // Check that new user-input value is a number. If not, default to the current value.
      if (!Number.isInteger(parsedQuantity)) {
        parsedQuantity = currentValue;
      }

      // Set the input element to our new user-input value or current value
      $target.val(parsedQuantity);

      // Return if current value is same as new value
      if (currentValue === parsedQuantity) {
        return;
      }
    } else {

      // Get new quantity if using the +/- increment buttons
      parsedQuantity = $target.attr('data-quantity');

      // Set our input as the new quantity
      $target.siblings('.js-qty-input').val(parsedQuantity);
    }

    // Run updateItem with our event, variant ID, and new quantity
    updateItem(evt, id, parsedQuantity);
  };


  function updateItem(evt, id, qty) {
    if (loading) {
      return;
    }

    loading = true;

    theme.CartUtilities.changeItem(id, qty)
      .then(function(cart) {
        updateSuccess(cart);
      }.bind(this))
      .catch(function(XMLHttpRequest) {
        updateError(XMLHttpRequest)
      }.bind(this))
      .always(function() {
        loading = false;
      }.bind(this));
  };


  function buildCart(cart) {

    loading = true;

    var cart = cart;
    var url = '';

    /**
     * Depending on whether we're on the cart template or outside of it, we pull
     * in a specific cart template. We're not using a templating library such as
     * Handlebars. This is a potentially more app-friendly solution as we can
     * re-run liquid. This solution is influenced by Maestrooo on their Prestige
     * and Warehouse themes.
     */
    if (window.theme.settings.template !== 'cart') {
      url = '/cart?view=drawer&timestamp=' + Date.now();
    } else {
      url = '/cart?timestamp=' + Date.now();
    }

    $.ajax(url, {
        method: 'GET',
        dataType: 'html'
      })
      .done(function(data, textStatus, jqXHR) {

        if (window.theme.settings.template !== 'cart' && window.theme.settings.cartType === 'drawer') {
          
          // Update Cart Drawer Items
          var tempElement = document.createElement('div');
          tempElement.innerHTML = data;

          var cartNodeParent = document.querySelector('.js-cart-content').parentNode;

          cartNodeParent.replaceChild(tempElement.querySelector('.js-cart-content'), document.querySelector('.js-cart-content'));

          theme.CartDrawer.open();

        } else {
          // We are forcing a location reload on the cart page to ensure we run
          // any necessary JS for 3rd party apps etc.
          window.location.reload();
        }

      })
      .fail(function() {
        console.log("Add to Cart Error");
      })
      .always(function() {
        loading = false;
        initEventListeners();
        
        /**
         * Ensure continue shopping button reinits close event
         */
        $('.js-drawer-close').on('click.drawer-cart', function(evt) {
          theme.CartDrawer.close(evt);
        });
      });

    $('.header__cart-count-value').text(cart.item_count);
  };


  function updateSuccess(cart) {
    buildCart(cart);
  };


  function updateError(XMLHttpRequest) {
    if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
      console.warn(XMLHttpRequest.responseJSON.description);
    }
  };

  return {
    init: init
  };

})();










/*==============================================================================
  #Product
==============================================================================*/

theme.Product = (function() {

  function Product(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    this.settings = {
      enableHistoryState: this.options['enableHistoryState'],
      namespace: '.product-' + sectionId,
      enableImageZoom: this.options['enableImageZoom'],
      showPaymentButton: this.options['showPaymentButton'],
      groupImagesByAlt: this.options['groupImagesByAlt'],
      namespace: '.product-' + sectionId
    };

    this.selectors = {
      productJson: 'ProductJson-' + sectionId,

      productImageWrapper: '.js-product-image-wrapper-' + sectionId,
      productMediaSlider: '.js-product-media-slider-' + sectionId,

      price: '.js-product-price-' + sectionId,
      comparePrice: '.js-product-compare-price-' + sectionId,

      addToCart: '.js-add-to-cart-' + sectionId,
      addToCartText: '.js-add-to-cart-text-' + sectionId,

      originalSelectorId: '.js-product-form-selector-master-' + sectionId,
      singleOptionSelector: '.js-product-form-selector-' + sectionId,

      originalSelectorId: '.js-product-form-selector-master-' + sectionId,
      singleOptionSelectorRadio: '.variant-button__input',
      singleOptionSelector: '.js-product-form-selector-' + sectionId,

      formContainer: '.js-product-form-' + sectionId
    };

    // Check this is a product object
    if (!$('#' + this.selectors.productJson).html()) {
      return;
    }

    // Parse our product json object
    this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);


    // Cache slider and image variables
    this.$productSlider = $(this.selectors.productMediaSlider);

    // We get our first product image
    this.$firstProductImage = this.$productSlider.find('img').first();

    // Initialise section
    this.init();

  }

  Product.prototype = $.extend({}, Product.prototype, {

    init: function() {
      this.productFormSetup();
      this.productImageSetup();
    },


    productFormSetup: function() {
      this.initAjaxProductForm();
      this.initVariants();
    },


    productImageSetup: function() {
      this.initSlider();
      this.initImageSwitch();
    },


    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelectorRadio,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productObject
      }

      this.variants = new slate.Variants(options);

      this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
      this.$container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantMedia.bind(this));
      
      if (this.settings.groupImagesByAlt) {
        this.$container.on('variantChange' + this.settings.namespace, this.updateVariantSlides.bind(this));
      }
    },


    updatePrice: function(evt) {

      var variant = evt.variant;

      if (variant) {

        // Update current price
        $(this.selectors.price).html(slate.Currency.formatMoney(variant.price, theme.settings.moneyFormat));

        if (variant.compare_at_price > variant.price) {

          // If on sale, update compare at price (aka regular price)
          $(this.selectors.comparePrice).html(slate.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
        }
      }
    },


    updateCartButton: function(evt) {

      var variant = evt.variant;
      var $dynamicPaymentButton;

      if (this.settings.showPaymentButton) {
        $dynamicPaymentButton = $('.shopify-payment-button');
      }

      if (variant) {

        if (variant.available) {

          // Remove disabled attribute and show Add to Cart text
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).html(theme.strings.addToCart);

          if (this.settings.showPaymentButton) {
            $dynamicPaymentButton.show();
          }

        } else {

          // Add disabled attribute and show Sold Out text
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.soldOut);
          if (this.settings.showPaymentButton) {
            $dynamicPaymentButton.hide();
          }
        }

      } else {

        // If variant does not exist 
        // Add disabled attribute and show Unavailable text
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).html(theme.strings.unavailable);
        if (this.settings.showPaymentButton) {
          $dynamicPaymentButton.hide();
        }
      }
    },


    updateVariantMedia: function(evt) {

      // variantImageChange evt stores our variant object
      var variant = evt.variant;

      // Retrieve index of our new image
      var $newMedia = $('.product-media__slide[data-media-id="' + variant.featured_media.id + '"]');
      var mediaIndex = this._slideIndex($newMedia);

      // If there is no index, slider is not initalized
      if (typeof mediaIndex === 'undefined') {
        return;
      }

      // Go to slide
      this.$productSlider.flickity( 'selectCell', mediaIndex);

    },


    initAjaxProductForm: function() {
      // If we are using a AJAX drawer, pass our form to AjaxProduct function
      if (theme.settings.cartType === 'drawer') {
        new theme.AjaxProduct($(this.selectors.formContainer));
      }
    },

    /**
     * Configures the thumbnail / image switching behaviour. This works if using
     * `a` elements to wrap our thumbnails, as it will prevent default behaviour.
     * We're not currently using this, but opting for `div` elements and Slick
     * sliders `asNavFor` functionality which links the thumbnail slider to
     * the main slider.
     */

    initImageSwitch: function() {

      var self = this;
      var $thumbnail = $('.product-media__thumb');

      // If thumbs don't exist, return
      if (!$thumbnail.length) {
        return;
      }

      // Prevent default behaviour on click of thumbs
      $thumbnail.on('click', function(evt) {
        evt.preventDefault();

        var $target = $(evt.currentTarget);
        var mediaId = $target.attr('data-media-id');

        self.$productSlider.flickity( 'selectCell', '[data-media-id="' + mediaId + '"]');
      });
    },


    initSlider: function() {
      var self = this;
      var initialSlideIndex = 0;
      var productSlides;
      var slideCount = 0;

      // If the slideshow exists, set some variables
      if (this.$productSlider) {
        productSlides = $('.product-media__slide');
        slideCount = parseInt(this.$productSlider.attr('data-media-count'));
      } else {
        productSlides = [];
      };


      // If zoom is enabled and not using a touch device, we initialise zoom
      // on our first image only.  
      if (!theme.config.isTouch) {
        var $image = $('.product-media__slide--is-visible').first();
        this.initZoom($image);
      };


      /**
       * If we have more than one slide, we initialise the slideshow
       */
      if (slideCount > 1) {

        /**
         * If the product groups variant images by ALT tag, we need to run some
         * code to determine what slides to show.
         */
        if (this.settings.groupImagesByAlt) {
          /**
           * A new array is created that will contain visible slides
           */
          var visibleSlides = [].slice.call(productSlides).filter(function(slide){
            return slide.classList.contains('product-media__slide--is-visible');
          });


          /**
           * The slider stores the selected/current variant image ID. If a slide
           * matches this, we set the index for our initial slide
           */
          visibleSlides.forEach(function(slide, index) {
            if (slide.getAttribute('data-media-id') === self.$productSlider.attr('data-initial-media-id')) {
              initialSlideIndex = index;
            }
          });
        }


        // Get the initial slide
        var initialMediaId = self.$productSlider.attr('data-initial-media-id');

        // Crappy way to prevent duplicate event listeners
        this.$productSlider.off('change.flickity');
        this.$productSlider.on('change.flickity', this.onSlideChange.bind(this));

        /**
         * Initialise flickity slider
         */
        this.$productSlider.flickity({
          prevNextButtons: true,
          pageDots: false,
          adaptiveHeight: true,
          contain: true,
          cellAlign: 'left',
          cellSelector: '.product-media__slide--is-visible',
          initialIndex: '[data-media-id="' + initialMediaId + '"]',
          draggable: false,
          arrowShape: {
            x0: 25,
            x1: 70, y1: 50,
            x2: 70, y2: 45,
            x3: 30
          }
        });
      };
    },


    setActiveThumbnail: function(mediaId) {

      // Remove active class from existing thumbnail
      $('.product-media__thumb--is-visible').removeClass('product-media__thumb--is-active');

      // Add active class to new active thumbnail
      $('.product-media__thumb--is-visible[data-media-id="' + mediaId +'"]').addClass('product-media__thumb--is-active');
    },


    /**
     * If we group variant images by ALT, depending on the variant chosen, we
     * may need to rebuild our slider to show only relevant images.
     */
    updateVariantSlides: function(evt) {

      // Store variables
      var variant = evt.variant;
      var self = this;
      var rebuildSlider = false;

      /**
       * Loop over each slide
       */
      $('.product-media__slide').each(function(imageIndex, slide) {

        var $slide = $(slide);

        /**
         * If slide has a data attribute of the data-group-name e.g. Size, Colour
         * we run further code.
         */
        if ($slide.attr('data-group-name')) {

          // Store group name as a variable e.g. Size, Colour
          var groupName = $slide.attr('data-group-name');

          // Loop over the product options
          self.options['productOptions'].forEach(function(option, optionIndex) {

            // If the product option matches the groupName
            if (option.toLowerCase() === groupName) {

              /** 
               * If the variant value matches the slide data-group-value, e.g.
               * variant colour value is red and data-group-value is red OR
               * it is the variant featured image and matches the data-image-id
               * We add a class to SHOW the slide
               */
              if (variant['option' + (optionIndex + 1)].toLowerCase() === $slide.attr('data-group-value') || variant['featured_image'] && variant['featured_image']['id'] === parseInt($slide.attr('data-image-id'))) {
                $slide.removeClass('product-media__slide--is-hidden').addClass('product-media__slide--is-visible');
              } else {
                // Else we hide the slide
                $slide.removeClass('product-media__slide--is-visible').addClass('product-media__slide--is-hidden');
              }
            }
            
          });

          // Set rebuildSlider to true
          rebuildSlider = true;
        };
      });

      // If rebuildSlider is true, we rebuild flickity
      if (rebuildSlider) {
        self.destroyImageSlider();
        self.createImageSlider();
        self.$productSlider.flickity('select', 0);
      }
    },


    onSlideChange: function(evt, index) {
      var self = this;

      var $newSlide = this.$productSlider.find('.product-media__slide--is-visible.is-selected');
      var mediaId = $newSlide.attr('data-media-id');

      self.setActiveThumbnail(mediaId);

      if (!theme.config.isTouch) {
        self.initZoom($newSlide);
      };
      this.$productSlider.flickity('resize');
    },


    destroyImageSlider: function() {
      if (this.$productSlider) {
        this.$productSlider.flickity('destroy');
      }
    },


    initZoom: function($image) {

      /**
       * Defensive code to check if we already have a zoomImg
       */
      var zoomImg = $image.find('.zoomImg');

      if (zoomImg.length) {
        return;
      }

      var self = this;

      var $productImage = $image.find('.product-media__image');
      var zoomUrl = $productImage.attr('data-zoom-url');

      /*
       * 1. We use a `custom` zoom behaviour that's been added to the zoom.js
       *    script. This allows the user to click to zoom, and exit by either
       *    click or mouseleave events.
       * 2. Set touch to false.
       */

      $productImage.parent().zoom({
        on: 'custom', /* [1] */
        url: zoomUrl,
        duration: 180,
        magnify: self.settings.imageZoomLevel,
        touch: true, /* [2] */
        onZoomIn: function() {
          $(this).addClass('image--is-zoomed');
        },
        onZoomOut: function() {
          $(this).removeClass('image--is-zoomed');
        }
      });
    },


    destroyZoom: function(evt) {
      $('product-media__slide').find('.zoomImg').each(function(index, element) {
        $(element).trigger('zoom.destroy');
      });
    },


    // Get slide index
    _slideIndex: function($el) {
      return $el.data('media-index');
    },


    onSelect: function() {
      
    }

  });

  return Product;

})();










/*==============================================================================
  #ProductRecommendations
==============================================================================*/

theme.ProductRecommendations = (function() {

  var selectors = {};

  var config = {};

  function ProductRecommendations(container) {
    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');
    
    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var self = this; 

    var slider = this.slider = '.js-product-rec-slider';

    var $slider = $(slider);

    this.loadRecommendations();
  }


  ProductRecommendations.prototype = $.extend({}, ProductRecommendations.prototype, {

    loadRecommendations: function() {
      var self = this;

      var url = '/recommendations/products?section_id=product-recommendations&product_id=' + self.options['productId'] + '&limit=' + self.options['productCount'];

      $.ajax(url, {
        method: 'GET',
        dataType: 'html'
      })
      .done(function(data, textStatus, jqXHR) {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = data;

        document.querySelector('.product-recommendations').innerHTML = tempElement.querySelector('.product-recommendations').innerHTML;

        self.initSlider();

        theme.Modals.init();
        theme.initQuickShop();
      })
      .fail(function() {
        console.log("Product Recommendations Loading error");
      })
      .always(function() {
      })
    },

    initSlider: function() {
      $('.js-product-rec-slider').flickity({
        "pageDots": false,
        "prevNextButtons": true,
        "pageDots": false,
        "cellAlign": 'left',
        "contain": true,
        "groupCells": true,
        "arrowShape": {
          "x0": 25,
          "x1": 70, "y1": 50,
          "x2": 70, "y2": 45,
          "x3": 30
        }
      });
    }

  });

  return ProductRecommendations;

})();










/*==============================================================================
  #RecentlyViewedProducts
==============================================================================*/

theme.RecentlyViewedProducts = (function() {

  var selectors = {};

  var config = {};

  function RecentlyViewedProducts(container) {
    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');
    
    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var self = this; 
;
    if (this.options['currentProductId']) {
      this.saveCurrentProduct();
    }

    var slider = this.slider = '.js-rvp-slider';
    var $slider = $(slider);

    this.loadProducts();
  }


  RecentlyViewedProducts.prototype = $.extend({}, RecentlyViewedProducts.prototype, {

    saveCurrentProduct: function() {

      var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
      var currentProductId = this.options['currentProductId'];

      if (items.indexOf(currentProductId) == -1) {
        items.unshift(currentProductId);
      }

      try {
        localStorage.setItem('recentlyViewedProducts', JSON.stringify(items.slice(0, 10)));
      } catch(error) {

      }
    },


    loadProducts: function() {

      var self = this;
      var queryString = self.getSearchQueryString();

      if (queryString === '') {
        return;
      }

      var template = 'recently-viewed-products';

      $.ajax('/search?view=' + template + '&type=product&q=' + queryString, {
        method: 'GET',
        dataType: 'html'
      })
      .done(function(data, textStatus, jqXHR) {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = data;

        document.querySelector('.recently-viewed-products-placeholder').innerHTML = tempElement.querySelector('[data-section-type="recently-viewed-products-section"] .recently-viewed-products-placeholder').innerHTML;

        self.initSlider();

        /**
         * Flickity needs to know height of elements prior to initialising.
         * We trigger the resize event after the products have loaded so
         * Flickity can get the size of elements.
         */
        setTimeout(function(){ 
          $('.js-rvp-slider').flickity('resize');
        }, 10);


        $('#shopify-section-recently-viewed-products').css('display', 'block');
      })
      .fail(function() {
        console.log('Recently Viewed Products Loading error');
      })
      .always(function() {
      })
    },


    getSearchQueryString: function() {
      var self = this;
      var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

      // If we are on a product template, we make sure to remove the main product from the recently viewed products
      if (items.indexOf(self.options['currentProductId'])) {
        items.splice(items.indexOf(self.options['currentProductId']), 1);
      }

      return items.map(function(item) {
        return 'id:' + item;
      }).join(' OR ');
    },


    initSlider: function() {
      $('.js-rvp-slider').flickity({
        "pageDots": false,
        "prevNextButtons": true,
        "cellAlign": 'left',
        "contain": true,
        "groupCells": true,
        "arrowShape": {
          "x0": 25,
          "x1": 70, "y1": 50,
          "x2": 70, "y2": 45,
          "x3": 30
        }
      });
    }

  });

  return RecentlyViewedProducts;

})();









/*==============================================================================
  #theme.initQuickShop
==============================================================================*/

theme.initQuickShop = function() {
  var $btn = $('.js-open-quick-shop');

  $btn.on('click', function(evt) {

    // Prevent any default link click behaviour
    evt.preventDefault();

    // Get the product url
    var url = $(this).attr('data-product-url');

    // Check if the URL already has a query string and adjust URL accoridngly
    if (url.indexOf('?') != -1) {
      url += '&view=quick-view';  
    } else {
      url += '?view=quick-view';
    }

    /**
     * Get current quick shop product URL. If a user clicks on same product
     * again, we don't need to reload. If they click on a different product,
     * we clear the modal before loading the new product for nicer experience.
     */
    var currentUrl = $('#QuickShopModal').attr('data-current-quick-shop-url');

    if (url != currentUrl) {
      $('#QuickShopModal .modal__body').html('');

      // Perform AJAX request to product content
      $.ajax(url, {
        method: 'GET',
        dataType: 'html'
      })
      .done(function(data, textStatus, jqXHR) {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = data;

        $('#QuickShopModal .modal__body').html(tempElement.querySelector('.product-section'));
        
        // Initialise product section
        var initSections = new theme.Sections();
        initSections.register('product-quick-view-template-section', theme.Product);

      }).fail(function() {
        console.log('Error pulling in QuickShopModal Product content');
      })
      .always(function() {
      });

      // Store current quick shop product URL
      $('#QuickShopModal').attr('data-current-quick-shop-url', url);
    }
    
  });
};










/*==============================================================================
  #Collection
==============================================================================*/

theme.Collection = (function() {

  var selectors = {};

  var config = {};

  function Collection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    // var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    this.settings = {};

    var video = '.js-hero-video';
    var $video = $('.js-hero-video');

    if ($video.length) {
      startMp4Playback(video).then(function() {
      }).catch(function(error) {
        makeVideoInteractable($video);
      })
    }

    function startMp4Playback(mp4video) {
      return document.querySelector(video).play();
    }

    function makeVideoInteractable($video) {
      $video.parent().addClass('.video-interactable');
    }

    // Initialise section
    this.init();
  }


  Collection.prototype = $.extend({}, Collection.prototype, {

    init: function() {
    }
  });

  return Collection;

})();










/*==============================================================================
  #AnnouncementBarSection
  - Dependent on Flickity in vendor.js
==============================================================================*/

theme.AnnouncementBarSection = (function() {

  function AnnouncementBarSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings') || '{}');

    this.slider = '.js-announcement-slider--' + sectionId;
    this.$slider = $(this.slider);
    this.flickityEnabled = false;

    this.init();
  }

  AnnouncementBarSection.prototype = $.extend({}, AnnouncementBarSection.prototype, {

    init: function() {
      if (!this.$slider.length || this.options['slideCount'] < 2) {
        return;
      }

      var args = {
        autoPlay: this.options['isAutoplay'] ? this.options['autoplaySpeed'] : false,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
        setGallerySize: true,
        cellAlign: 'center',
        adaptiveHeight: true
      };

      this.$slider.flickity(args);
      this.flickityEnabled = true;

      if (typeof theme.StickyHeader !== 'undefined' && theme.StickyHeader.setHeight) {
        theme.StickyHeader.setHeight();
      }
    },

    forceReload: function() {
      if (this.flickityEnabled) {
        this.$slider.flickity('destroy');
        this.flickityEnabled = false;
      }
      this.init();
    },

    onUnload: function() {
      if (this.flickityEnabled) {
        this.$slider.flickity('destroy');
        this.flickityEnabled = false;
      }
    },

    onSelect: function() {
      if (this.flickityEnabled && this.options['isAutoplay']) {
        this.$slider.flickity('pausePlayer');
      }
    },

    onDeselect: function() {
      if (this.flickityEnabled && this.options['isAutoplay']) {
        this.$slider.flickity('unpausePlayer');
      }
    },

    onBlockSelect: function(evt) {
      if (!this.flickityEnabled) {
        return;
      }

      var $slide = this.$slider.find('.announcement-bar__slide--' + evt.detail.blockId);
      var slideIndex = $slide.data('slide-index');

      this.$slider.flickity('selectCell', slideIndex).flickity('pausePlayer');
    },

    onBlockDeselect: function() {
      if (this.flickityEnabled && this.options['isAutoplay']) {
        this.$slider.flickity('unpausePlayer');
      }
    }
  });

  return AnnouncementBarSection;
})();



/*==============================================================================
  #StickyHeader
  - Desktop fixed header group; hide on scroll down, show on scroll up
==============================================================================*/

theme.StickyHeader = (function() {
  var mq = window.matchMedia('(min-width: 1024px)');
  var $group = null;
  var lastScrollTop = 0;
  var threshold = 100;
  var hiddenClass = 'header-group--hidden';
  var bound = false;

  function getGroup() {
    if (!$group || !$group.length) {
      $group = $('#HeaderGroup');
    }
    return $group;
  }

  function setHeight() {
    var $el = getGroup();
    if (!$el.length) {
      return;
    }

    var height = 0;
    $el.find('.shopify-section--announcement-bar, .shopify-section--header').each(function() {
      height += $(this).outerHeight(true);
    });

    if (height === 0) {
      height = $el.outerHeight(true);
    }

    document.documentElement.style.setProperty('--header-group-height', height + 'px');
  }

  function onScroll() {
    if (!mq.matches) {
      getGroup().removeClass(hiddenClass);
      return;
    }

    var st = $(window).scrollTop();

    if (st < threshold) {
      getGroup().removeClass(hiddenClass);
      lastScrollTop = st;
      return;
    }

    if (st > lastScrollTop) {
      getGroup().addClass(hiddenClass);
    } else {
      getGroup().removeClass(hiddenClass);
    }

    lastScrollTop = st;
  }

  function onResize() {
    setHeight();
    if (!mq.matches) {
      getGroup().removeClass(hiddenClass);
    }
  }

  function init() {
    if (!getGroup().length) {
      return;
    }

    setHeight();

    if (!bound) {
      $(window).on('scroll.stickyHeader', onScroll);
      $(window).on('resize.stickyHeader', onResize);
      bound = true;
    }

    onScroll();
  }

  return {
    init: init,
    setHeight: setHeight
  };
})();



/*==============================================================================
  #SlideshowSection
  - Dependent on Flickity in vendor.js
==============================================================================*/

theme.SlideshowSection = (function() {

  function SlideshowSection(container) {

    // Store container as jQuery variable
    var $container = this.$container = $(container);
    
    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get slideshow by ID
    var slideshow = this.slideshow = '.js-slideshow--' + sectionId;

    var $slideshow = this.$slideshow = $(this.slideshow);

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var $imageContainer = $(container).find('.slideshow');

    // Load image section allows for adding classes whilst loading so we can
    // animate
    if ($imageContainer.length) {
      theme.loadImageSection($imageContainer);
    }

    this.init();
  }


  SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {

    init: function() {
      
      // Store options for Flickity
      var args = {
        autoPlay: this.options['isAutoplay'] ? this.options['autoplaySpeed'] : false,
        pageDots: false,
        prevNextButtons: this.options['showArrows'],
        setGallerySize: false,
        wrapAround: true,
        arrowShape: {
          x0: 25,
          x1: 70, y1: 50,
          x2: 70, y2: 45,
          x3: 30
        }
        // cellSelector: 'product--media'
      };

      this.$slideshow.flickity(args);
      
    },


    /**
     * Shopify Theme Editor events
     */

    forceReload: function() {
      this.init();
    },

    // On unload, destroy slideshow
    onUnload: function() {
      this.$slideshow.flickity('destroy');
    },

    // When working on the section, pause the slideshow if it has autoplay
    onSelect: function() {
      this.$slideshow.flickity('pausePlayer');
    },

    // When leaving the section, play the slideshow if it has autoplay
    onDeselect: function() {
      this.$slideshow.flickity('unpausePlayer');
    },

    // On block select, ignore cloned slides, go to selected slide, and pause
    // autoplay
    onBlockSelect: function(evt) {
      var $slide = $('.slide--' + evt.detail.blockId);
      var slideIndex = $slide.data('slide-index');

      // Go to selected slide, pause autoplay
      this.$slideshow.flickity('selectCell', slideIndex).flickity('pausePlayer');
    },

    // On block deselect, play slideshow if it has autoplay
    onBlockDeselect: function() {
      this.$slideshow.flickity('unpausePlayer');
    }
  });

  return SlideshowSection;
})();










/*==============================================================================
  #FeaturedCollectionSection
==============================================================================*/

theme.FeaturedCollectionSection = (function() {

  function FeaturedCollectionSection(container) {
    var $container = this.$container = $(container);

    // Store sectionId as variable
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Get section settings, parse JSON, and store as options
    var options = this.options = JSON.parse(container.getAttribute('data-section-settings'));

    var slider = this.slider = '.js-featured-collection-slider--' + sectionId;

    var $slider = $(slider);

    var defaults = this.defaults = {
      pageDots: false,
      prevNextButtons: true,
      pageDots: false,
      cellAlign: 'left',
      contain: true,
      groupCells: true,
      arrowShape: {
        x0: 25,
        x1: 70, y1: 50,
        x2: 70, y2: 45,
        x3: 30
      }
    };

    var self = this;

    var slideCount = this.options['slideCount'];
    var sliderIsActive;

    self.init($slider, this.defaults);
  }

  FeaturedCollectionSection.prototype = $.extend({}, FeaturedCollectionSection.prototype, {

    init: function(obj, args) {
      obj.flickity(args);
      sliderIsActive = true;
    },

    destroy: function(slider) {
      slider.flickity('destroy');
      sliderIsActive = false;
    },

    onSelect: function() {

    },

    onUnload: function() {

    }
  });

  return FeaturedCollectionSection;
})();




















/*==============================================================================
  #TEMPLATES
==============================================================================*/


theme.customerAddresses = function() {

  var $addressForms = $('.js-address-form');

  // If no address forms exist, we don't run the code
  if (!$addressForms.length) {
    return;
  }

  // Certain countries require province selection such as Spain, Canada, UAE
  // We use Shopify.CountryProvinceSelector to show/hide the province selector
  if (Shopify) {
    $('.js-address-country').each(function() {

      var $container = $(this);
      var countryId = $container.data('country-id');
      var provinceId = $container.data('province-id');
      var provinceContainerId = $container.data('province-container-id');

      new Shopify.CountryProvinceSelector(
        countryId,
        provinceId,
        {
          hideElement: provinceContainerId
        }
      );
    });
  }

  // Delete address event handler
  $('.js-address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
};










/*==============================================================================
  #Customer Login
  - Largely based off Slate
  - Handles login / recover password form
==============================================================================*/

theme.customerLogin = function() {

  var config = {
    recoverPasswordToggle: '.js-toggle-recover-form',
    recoverPasswordForm: '#RecoverPasswordForm'
  };

  // Check recover password form exist
  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordToggle).on('click', onShowHidePasswordForm);
  // $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
};




















/*==============================================================================
  #INIT
==============================================================================*/

theme.init = function() {
  /**
   * Tab Handling
   * We use CSS to remove focus outlines on a lot of elements for aesthetic
   * reasons.
   * In order to maintain accessibility, we can recognise if a user is tabbing
   * and add an `is-tabbing` class which will allow us to add focus outlines in 
   * the CSS.
   */

  $(document.documentElement).on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      $(document.documentElement).addClass('is-tabbing');
      $(document.documentElement).off('keyup.tab');
    }
  });


  /**
   * SMOOTH SCROLLING for In-page anchor links
   * Based on:
   * https://stackoverflow.com/questions/7717527/smooth-scrolling-when-clicking-an-anchor-link
   */
  $(document).on('click', 'a[href^="#"]', function(evt) {
    evt.preventDefault();

    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
  });

  theme.customerLogin();
  theme.customerAddresses();
  theme.initQuickShop();
  theme.setBreakpoints();
  theme.Cart.init();
  theme.Modals.init();
  theme.Collapsibles.init();
  theme.ajaxNewsletterForm();
  
  window.addEventListener('globoFilterRenderCompleted', function () {      
      theme.initQuickShop();
      
      theme.Cart.init();
      theme.Modals.init();
      //theme.Collapsibles.init();
      //theme.setBreakpoints();
      // theme.ajaxNewsletterForm();
      //theme.customerAddresses();
  });
};










/*==============================================================================
  #DOC READY
==============================================================================*/

$(document).ready(function() {

  theme.init();
  
  if (typeof ga === 'function') {
    ga('create', 'UA-107753186-1', 'auto');
  }

  var sections = new theme.Sections();
  sections.register('collection-template-section', theme.Collection);
  sections.register('product-template-section', theme.Product);
  sections.register('product-recommendations-section', theme.ProductRecommendations);
  sections.register('recently-viewed-products-section', theme.RecentlyViewedProducts);
  sections.register('header-section', theme.HeaderSection);
  sections.register('drawer-nav-section', theme.DrawerMenuSection);
  sections.register('announcement-bar-section', theme.AnnouncementBarSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('featured-collection-section', theme.FeaturedCollectionSection);

  theme.StickyHeader.init();


  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });


  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'table-wrapper-overflow',
  });


  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });
});


var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}